import { useContext } from 'react'
import { LessonExtraContentsContext } from '@contexts/LessonExtraContentsContext'

export const useLessonExtraContents = () => {
  return useContext(LessonExtraContentsContext)
}
